import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBungalow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	width: "100%",
	height: "100%",
	style: {
		shapeRendering: "geometricPrecision",
		textRendering: "geometricPrecision",
		imageRendering: "optimizeQuality",
		fillRule: "evenodd",
		clipRule: "evenodd"
	},
	viewBox: "0 0 27940 21590",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Layer_x0020_1",
		children: [/* @__PURE__ */ _jsx("metadata", { id: "CorelCorpID_0Corel-Layer" }), /* @__PURE__ */ _jsx("g", {
			id: "_870610144",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "fil0",
					d: "M15828 15759l3869 -9 5 4109 -3903 -14 8 -4037c14,-56 -4,-15 21,-49zm-651 -134l0 0c0,-242 230,-491 469,-491l4265 0c189,0 424,243 424,535l0 4176 2189 0 0 -6252 -17351 0 0 6252 10004 0 0 -4220zm-9959 -5114l0 0 17261 0c74,0 99,124 156,268l849 2189 -19248 0c2,-113 406,-1087 466,-1254 37,-106 77,-195 120,-303l303 -770c24,-70 18,-130 93,-130zm9334 -2746l0 0 3215 0 0 2121 -3215 0 0 -2121zm-7280 -3082l0 0 4020 0 0 5203 -4020 0 0 -5203zm11121 5136l0 0 0 -2054 3461 0 0 2121 -3394 0c-52,0 -67,-15 -67,-67zm-3908 -4689l0 0 7436 0 937 1987 -9289 0 916 -1987zm-5225 -3216l0 0 1607 2144 -3170 0 1563 -2144zm-2613 2680l0 0 0 5292 -1608 0c-272,0 -428,234 -486,451 -48,180 -188,497 -260,678 -204,510 -501,1349 -699,1803 -100,231 -307,580 -6,752 122,70 216,23 380,23l580 0 0 6431c0,274 255,469 536,469l17551 0c215,0 449,-169 502,-414l34 -6486c133,0 843,27 913,-2 334,-142 128,-544 25,-802l-961 -2434c-115,-409 -237,-469 -647,-469l0 -2121 826 0c424,0 352,-372 244,-628 -156,-373 -443,-927 -497,-1039 -74,-155 -124,-296 -200,-447l-421 -898c-72,-181 -136,-271 -398,-271l-7659 0c-302,0 -362,86 -428,265l-1062 2287c-113,262 -325,731 194,731l827 0 0 2121 -1988 0 0 -5314c0,-128 -31,-214 -84,-296l-2164 -2838c-179,-220 -216,-372 -454,-372 -214,0 -277,169 -411,348l-1851 2526c-144,185 -328,373 -328,654z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "fil1",
					d: "M11627 16540c0,386 -16,849 625,849 246,0 462,21 651,-130 248,-197 197,-461 197,-786 0,-268 -209,-513 -469,-513 -390,0 -1004,-117 -1004,580z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "fil0",
					d: "M7920 16518l0 357c0,239 225,514 469,514l536 0c239,0 469,-249 469,-491 0,-263 32,-453 -53,-640 -162,-352 -580,-276 -908,-276 -314,0 -513,251 -513,536z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "fil2",
					d: "M2918 18796l7 -7c-1,0 -9,4 -7,7z",
					fill: "#616160"
				})
			] })
		})]
	})]
});
const ForwardRef = forwardRef(SvgBungalow);
export default ForwardRef;
